import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import BlobImage from 'components/blobImage';
import { hasModule } from 'helpers/profile';
import { SystemText } from '@salesperformanceint/e4shared';
import { getPermissions } from 'helpers/permissions';

export const Person = props => {
    const { data, user, coaching, downline, history } = props;

    const [permissions, setPermissions] = React.useState(getPermissions());

    const isManager = user.id === data.id || downline?.find(d => d.id === data.id);
    const isAdministrator = user.administrator;

    const goTo = (event, link) => {
        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
        history.push(link);
    };

    React.useEffect(() => {
        if (data?.id && user?.id) {
            setPermissions(getPermissions(data, user, coaching, downline));
        }
    }, [data?.id, user?.id]);

    const st = (s, x) => SystemText(`Search/Results/Person/${s}`, x);

    const links = {
        blog: `/blog/${data.id}`,
        reviews: `/develop/reviews/${data.id}`,
        objectives: `/objectives/${data.id}`,
        pathways: `/develop/pathways/${data.id}`,
        performanceDashboard: `/develop/performance-dashboard/${data.id}`,
        team: `/search?manager=${data.id}&name=${data.name}`,
    };

    return (
        <div className="search-result box" style={{ cursor: 'default' }}>
            <div className="image-holder hidden-xs">
                <BlobImage folder="avatar" initials={data.initials} src={data.image} width="75" height="75" />
            </div>
            <div>
                <label className="label label-primary">
                    <i className="mr10 fa fa-user" />
                    {st('Title')}
                </label>
                <h2>{data.name}</h2>
                {data.manager_Fullname && (
                    <div className="mb2">
                        {st('Manager')}:{' '}
                        <Link to={`/search/${data.manager_Fullname}`}>
                            <BlobImage
                                folder="avatar"
                                initials={data.manager_Initials }
                                src={data.manager_Avatar}
                                className="mr5 ml5"
                                width="20"
                                height="20"
                            />
                            {data.manager_Fullname}
                        </Link>
                    </div>
                )}
                {data.job_Title && <span>{data.job_Title}</span>}
                {data.departments && (
                    <span>
                        {st('Department')} : {data.departments}
                    </span>
                )}
                {data.locations && (
                    <span>
                        {st('Location')} : {data.locations}
                    </span>
                )}
                <div className="table-btns mt5">
                    {hasModule(user, 'blogs') && (
                        <button onClick={event => goTo(event, links.blog)} className="btn btn-default btn-xs">
                            {st('Blog')}
                        </button>
                    )}
                    {hasModule(user, 'objectives') && permissions.objectives.canView && (
                        <button onClick={event => goTo(event, links.objectives)} className="btn btn-default btn-xs">
                            {st('Objectives')}
                        </button>
                    )}
                    {permissions.one2ones.canView && (
                        <button
                            onClick={event => goTo(event, links.performanceDashboard)}
                            className="btn btn-default btn-xs"
                        >
                            {st('121s')}
                        </button>
                    )}
                    {permissions.reviews.canView && (
                        <button onClick={event => goTo(event, links.reviews)} className="btn btn-default btn-xs">
                            {st('Reviews')}
                        </button>
                    )}
                    {hasModule(user, 'pathways') && permissions.pathways.canView && (
                        <button onClick={event => goTo(event, links.pathways)} className="btn btn-default btn-xs">
                            {st('Pathways')}
                        </button>
                    )}
                    {data.isManager && (isManager || isAdministrator) && (
                        <button onClick={event => goTo(event, links.team)} className="btn btn-default btn-xs">
                            {st('Team')}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default withRouter(Person);